import React, { Component } from 'react';
import 'bootstrap/dist/css/bootstrap.css';
import PermissionWrapper from '../../auth/PermissionWrapper';
import Widget from '../HomeWidgets/Widget';
import BackOfficeTechnologyContainer from '../BackOfficeTechnology/BOTRequestsContainer';

class LandingDefault extends Component {

    render() {
        this.props.info('LandingDefault.js/render');
        return (
            (Object.keys(this.props.userEmployee).length > 0) ?
                //     (((this.props.clients.filter(client => client.users.findIndex(user => user === this.props.user) > -1)).length !== 1) ?
                //         <>
                <>
                    <PermissionWrapper hidden={true} refreshUser={this.props.refreshUser} {...this.props} {...this.state} allowedPermission="Show Home Page BOT">
                        <BackOfficeTechnologyContainer {...this.props} singleEmployee={true} />
                    </PermissionWrapper>
                    <PermissionWrapper hidden={true} refreshUser={this.props.refreshUser} {...this.props} {...this.state} allowedPermission="Show Home Page Widgets">
                        <Widget
                            title="Primary Customers"
                            employeeClient={this.props.userEmployee.primaryCustomers}
                            info={this.props.info}
                            log={this.props.log}
                            refreshUser={this.props.refreshUser}
                            user={this.props.user}
                            userEmployee={this.props.userEmployee}
                            addToast={this.props.addToast}
                            clientToken={this.props.clientToken}
                            handleChangeUserEmployee={this.props.handleChangeUserEmployee}
                        />
                        <Widget
                            title="Secondary Customers"
                            employeeClient={this.props.userEmployee.secondaryCustomers}
                            info={this.props.info}
                            log={this.props.log}
                            refreshUser={this.props.refreshUser}
                            user={this.props.user}
                            userEmployee={this.props.userEmployee}
                            addToast={this.props.addToast}
                            clientToken={this.props.clientToken}
                            handleChangeUserEmployee={this.props.handleChangeUserEmployee}
                        />
                        <Widget
                            title="Team Customers"
                            employeeClient={this.props.userEmployee.teamCustomers}
                            info={this.props.info}
                            log={this.props.log}
                            refreshUser={this.props.refreshUser}
                            user={this.props.user}
                            userEmployee={this.props.userEmployee}
                            addToast={this.props.addToast}
                            clientToken={this.props.clientToken}
                            handleChangeUserEmployee={this.props.handleChangeUserEmployee}
                        />
                        {/* <HomeWidgets {...this.props} /> */}
                    </PermissionWrapper>
                </>
                // {/* <Row>
                //     <Col>
                //         <CollapseCard title="Clients" open={false}>
                //             <Container>

                //                 {this.props.clients.filter(client => client.active === true && client.users.findIndex(user => user === this.props.user) > -1).map(client => (
                //                     <Row key={client.id} className="mainRow">
                //                         <Col md={12} className="text-left">
                //                             <Link to={{ pathname: '/company/' + client.id }}>{client.client}</Link>
                //                         </Col>
                //                     </Row>
                //                 ))}
                //             </Container>
                //         </CollapseCard>
                //     </Col>
                // </Row> */}
                //     </>
                //     :
                //     <>{this.props.clients.filter(client => client.active === true && client.users.findIndex(user => user === this.props.user) > -1).map(client => (
                //         <Client clientId={client.id} {...this.props} ></Client>
                //     ))}</>
                // )
                :
                <h3>Please have an administrator assign an employee record to your user profile.</h3>
        );

    }
}

export default LandingDefault;
